import { getErrorMessage } from '../errorBuilder';
import { get, post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getUsers = async (params) => {
  const builder = new UrlBuilder(`/clients/list-users`);
  builder.add('page', params?.page || 1);
  builder.add('pageSize', params?.limit || 10);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const deleteUser = async (payload) => {
  const builder = new UrlBuilder(`/clients/delete-user`);

  try {
    const response = await post(builder.toString(), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const inviteUser = async () => {
  const builder = new UrlBuilder(`/clients/invite`);

  try {
    const response = await get(builder.toString());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
